$(document).ready(function () {

    $('#main #list-articles .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:3
            }
        }
    });

    $('.read-article').on('click', function () {
        var header_height = $('header#header').height();

        $('body, html').animate({
            scrollTop: $('#content').offset().top - header_height
        }, 700);
        
        return false;
    })

    $(document).on( 'click', '.comment-form p.stars a', function() {
        var $star   	= $( this ),
            $rating 	= $( this ).closest( '.comment-form' ).find( 'select[name="rating"]' ),
            $container 	= $( this ).closest( '.stars' );

        $rating.val( $star.text() );
        $star.siblings( 'a' ).removeClass( 'active' );
        $star.addClass( 'active' );
        $container.addClass( 'selected' );

        return false;
    });


});